export default __webpack_public_path__ + "static/media/StorePOreturn.b2b7dc76.svg";